import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
import { Link } from 'gatsby';
import { getStoryblokAlt } from '../../helpers/common';

const getStoryblokDimensions = (url) => {
  const [rawWidth, rawHeight] = url?.split('/')[5]?.split('x') || [];
  const width = Number.parseInt(rawWidth, 10);
  const height = Number.parseInt(rawHeight, 10);

  return {
    width: Number.isNaN(width) ? undefined : width,
    height: Number.isNaN(height) ? undefined : height,
  };
};

export default function UseCasesTiles({ blok }) {
  const { component } = blok;

  const styles = clsx(
    `${component} mt-[60px] lg:mt-20 grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-2 md:gap-6`,
  );

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      {blok?.use_case?.map((item) => (
        (() => {
          const imageUrl = item?.content?.image?.filename;
          const { width, height } = getStoryblokDimensions(imageUrl);
          return (
        <div className="relative h-full overflow-hidden" key={item.title}>
          <Link
            key={item.slug}
            to={`/${item.full_slug}`}
            className="flex mx-auto aspect-[24/10] w-full relative group"
          >

            <img
              src={imageUrl}
              alt={getStoryblokAlt(item?.content?.image, item.short_description || 'Use case image')}
              width={width}
              height={height}
              className="w-auto object-cover h-full absolute top-0 left-0"
              loading="lazy"
              decoding="async"
            />

            <div className="bg-latori-green-dark opacity-90 w-full h-full absolute bottom-0 left-0 transition-[height] group-hover:h-[0%]" />
            <div className="w-full h-full absolute top-0 left-0 flex flex-col justify-center items-start px-4 group-hover:opacity-0 transition-opacity text-white">
              <h2 className="text-2xl">{item?.content?.seo_title}</h2>
              <p
                dangerouslySetInnerHTML={{ __html: item?.content?.seo_description }}
                className="hidden md:block md:line-clamp-3"
              />
            </div>
          </Link>
        </div>
          );
        })()
      ))}
    </div>
  );
}
